import { render } from "./Homedetail.vue?vue&type=template&id=56f36d88&scoped=true"
import script from "./Homedetail.vue?vue&type=script&lang=js"
export * from "./Homedetail.vue?vue&type=script&lang=js"

import "./Homedetail.vue?vue&type=style&index=0&id=56f36d88&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f36d88"]])

export default __exports__